export default "__VITE_ASSET__FXy$JEte__"